<template >
  <div class="bodyback min-vh-100">
    <notifications></notifications>
    <div class="overimg"></div>
    <div class="main-content mt-0">
      <div class="container pb-0">
        <div
          class="
            row row
            align-items-center
            justify-content-center
            d-flex
            vh-100
          "
        >
          <div class="col-lg-5 col-md-7">
            <div class="card mb-0">
              <div class="card-header mb-3">
                <div class="text-dark text-center">
                  <h1 class="title-one mb-2">
                    <strong>Forgot Password</strong>
                  </h1>

                  <img
                    src="@/assets/img/rhombuss-dispath-pos.png"
                    alt="rhombuss"
                    class="logo-home d-block text-center"
                  />
                </div>
              </div>
              <div class="card-body px-lg-4">
                <span class="d-block f2 text-center mb-3">
                  We will send you an email with a link to retrieve your
                  password
                </span>

                <validation-observer
                  v-slot="{ handleSubmit }"
                  ref="formValidator"
                >
                  <form
                    role="form"
                    @submit.prevent="handleSubmit(requestNewPassword)"
                  >
                    <base-input
                      input-class
                      label="Email"
                      placeholder="Email"
                      :rules="{ required: true, email: true }"
                      name="Email"
                      v-model="email"
                    ></base-input>

                    <div class="text-center">
                      <base-button
                        type="primary"
                        native-type="submit"
                        size="sm"
                        class="mt-4"
                        >Send</base-button
                      >
                    </div>
                  </form>
                </validation-observer>

                <div class="loading mt-3" v-if="loader">
                  <div class="dot"></div>
                  <div class="dot"></div>
                  <div class="dot"></div>
                  <div class="dot"></div>
                  <div class="dot"></div>
                </div>
              </div>
            </div>

            <div class="row">
              <div class="col-lg-6 col-md-6 col-sm-6 col-12"></div>
              <div class="col-lg-6 col-md-6 col-sm-6 col-12 alinmov2 pt-2 pb-2">
                <router-link to="/login" class="text-light font-weight-600"
                  >Sign Up</router-link
                >
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { mapGetters, mapActions, mapMutations } from "vuex";
import Swal from "sweetalert2";
import endpoint from "../../Commons/Services";
export default {
  data() {
    return {
      email: "",
    };
  },
  methods: {
    async requestNewPassword() {
      try {
        this.setLoader(true);
        const isValid = await this.$refs.formValidator.validate();
        if (isValid) {
          let { data } = await endpoint.auth.services.forgotPassword(
            this.email
          );
          if (data.status) {
            this.setLoader(false);
            let result = await Swal.fire({
              title: "Success",
              html: "We have sent you an email to the address provided. Check your inbox",
              imageUrl: "../../img/icons/alerts/success.png",
              buttonsStyling: false,
              focusConfirm: false,
              reverseButtons: true,
              confirmButtonText: "Accept",
              customClass: {
                confirmButton: "btn btn-primary btn-small-one",
              },
            });

            if (result.value) {
              this.$router.push("/login");
            } else {
              this.$router.push("/login");
            }
          } else {
            this.setLoader(false);
            let result = await Swal.fire({
              title: "Error",
              html: "Sorry, your request could not be processed, please try again.",
              imageUrl: "../../img/icons/alerts/error.png",
              buttonsStyling: false,
              focusConfirm: false,
              reverseButtons: true,
              confirmButtonText: "Accept",
              customClass: {
                confirmButton: "btn btn-primary btn-small-one",
              },
            });
            if (result.value) {
              this.$router.push("/login");
            } else {
              this.$router.push("/login");
            }
          }
        }
      } catch (error) {
        this.setLoader(false);
        let result = await Swal.fire({
          title: "Error",
          html: "Sorry, your request could not be processed, please try again.",
          imageUrl: "../../img/icons/alerts/error.png",
          buttonsStyling: false,
          focusConfirm: false,
          reverseButtons: true,
          confirmButtonText: "Accept",
          customClass: {
            confirmButton: "btn btn-primary btn-small-one",
          },
        });
        if (result.value) {
          this.$router.push("/login");
        } else {
          this.$router.push("/login");
        }
      }
    },
    ...mapMutations(["setLoader"]),
  },
  computed: {
    ...mapGetters(["loader"]),
  },
};
</script>
